import { css } from '@emotion/react';

export default css({
  '.form': {
    alignItems: 'center',
    justifyContent: 'center',
    width: 'max-content',
    '&__body-text': {
      marginBottom: '0',
    },
    '&__footer': {
      marginTop: '12px',
      gap: '8px',
      justifyContent: 'flex-end',
      padding: '12px 0',
    },
  },
});
